export const SET_SALES = "@@app/SET_SALES";
export const SET_DATA_SALES_STATE = "@@app/SET_DATA_SALES_STATE";
export const SET_DATA_SALES = "@@app/SET_DATA_SALES";
export const RESET_DATA_SALES = "@@app/RESET_DATA_SALES";
export const RESET_DATA_SALES_LOGOUT = "@@app/RESET_DATA_SALES_LOGOUT";
export const SET_SEATS_TO_AVAILABLE = "@@app/SET_SEATS_TO_AVAILABLE";
export const SET_SEATS_CHANGED_TO_SELECTED = "@@app/SET_SEATS_CHANGED_TO_SELECTED";
